import { createRouter, createWebHistory } from 'vue-router'
import { localStorageService } from '@/services/localStorageService'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/LoginView.vue')
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/RegisterView.vue')
    },
    {
      path: '/create-company',
      name: 'CreateCompany',
      component: () => import('@/views/CreateCompany.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/HomeView.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'Dashboard',
          components: {
            dashboard: () => import('@/views/DashboardView.vue')
          }
        },
        {
          path: 'products',
          name: 'Products',
          components: {
            dashboard: () => import('@/views/ProductsView.vue')
          }
        },
        {
          path: 'new-material/:id?',
          name: 'NewMaterial',
          components: {
            dashboard: () => import('@/views/NewMaterial.vue')
          },
          meta: { requiresManager: true }
        },
        {
          path: 'material/:id',
          name: 'MaterialDetails',
          components: {
            dashboard: () => import('@/views/MaterialDetails.vue')
          }
        },
        {
          path: 'employees',
          name: 'Employees',
          components: {
            dashboard: () => import('@/views/EmployeesView.vue')
          },
          meta: { requiresManager: true }
        },
        {
          path: 'stock',
          name: 'Stock',
          components: {
            dashboard: () => import('@/views/StockView.vue')
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = localStorageService.getCurrentUser()

  if (to.meta.requiresAuth && !currentUser) {
    next({ name: 'Login' })
  } else if (to.meta.requiresManager && currentUser?.role !== 'manager') {
    next({ name: 'Dashboard' })
  } else if ((to.name === 'Login' || to.name === 'Register') && currentUser) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
